module.exports = __webpack_public_path__ + "img/mech-poster_en.a9d03cc.jpg";